export const toggleSizes = ["small", "large"] as const;

export type ToggleSize = (typeof toggleSizes)[number];
